import styled from "styled-components";

const StyledP = styled.p`
  font-size: 0.82rem !important;
  margin: 0 !important;
  padding: 0 !important;
  color: var(--default-color-font) !important;
`;

export default StyledP;
